(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    var box = document.getElementById('pdpWriteReview');

    // Магазин работает в modal-флоу Judge.me v3 (jdgmSettings:
    // modal_write_review_flow=true, review_form_location=in_store_popup):
    // клик по внутреннему тогглу .jdgm-write-rev-link (у нас скрыт в CSS)
    // вызывает showModalPage() — модалка формы монтируется в BODY, а не
    // инлайн в виджет. Отсюда правила:
    //  - «форма открыта» = видимая .jdgm-write-review-modal в document
    //    (инлайн .jdgm-form-wrapper проверяем тоже — на случай смены флоу);
    //  - «настоящий» клик — РОВНО ОДИН на каждое открытие дисклоужера, и
    //    только когда form.js Judge.me готов: его init снимает инлайновый
    //    display:none с линка (наш CSS прячет классом, инлайн не трогает).
    //    Клики до готовности безвредны: делегированный хендлер main.js
    //    лишь лениво подгружает form.js, а untrusted click не выполняет
    //    переход по href="#";
    //  - после «настоящего» клика и при закрытии details ретраи гасятся
    //    СРАЗУ. Иначе синтетические клики переоткрывали бы модалку, которую
    //    пользователь только что закрыл (баг «закрывается с третьего тапа»).
    var formTimer = null;

    function cancelFormRetries() {
      if (formTimer) {
        window.clearInterval(formTimer);
        formTimer = null;
      }
    }

    function jdgmFormVisible() {
      var els = [
        document.querySelector('.jdgm-write-review-modal'),
        box.querySelector('.jdgm-form-wrapper, form.jdgm-form'),
      ];
      return els.some(function (el) {
        return el && el.getClientRects().length > 0;
      });
    }

    function ensureJdgmForm() {
      if (!box || formTimer || jdgmFormVisible()) return;
      var tries = 0;
      formTimer = window.setInterval(function () {
        tries += 1;
        if (!box.open || tries > 27 || jdgmFormVisible()) {
          cancelFormRetries();
          return;
        }
        var link = box.querySelector('.jdgm-write-rev-link');
        if (!link) return;
        var jdgmReady = link.style.display !== 'none';
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        if (jdgmReady) cancelFormRetries();
      }, 300);
    }

    // Форма раскрывается ТОЛЬКО от живого жеста: клик по хедер-ссылке или
    // тап по summary. Открытый <details> сам по себе форму не монтирует —
    // иначе модалка Judge.me всплывала бы поверх PDP без единого клика:
    //  - при серверном рендере с `open` (так было у товаров без карточек);
    //  - при восстановлении состояния details браузером после F5/bfcache;
    //  - при раскрытии details браузером по хэшу #pdpWriteReview, который
    //    остаётся в URL, если по ссылке кликнули до загрузки скриптов.
    // Отсюда флаг intent: ставится в момент жеста, гасится сразу после
    // первого toggle. Закрытие details по-прежнему мгновенно отменяет
    // ожидающие ретраи (фикс «закрывается с третьего тапа»).
    var intent = false;

    if (box) {
      box.addEventListener('click', function (e) {
        // Тап по summary — единственный клик внутри details, который его
        // переключает; клики по самой форме intent не поднимают.
        if (e.target.closest && e.target.closest('.pdp-writerev__summary')) intent = true;
      });
      box.addEventListener('toggle', function () {
        if (box.open && intent) ensureJdgmForm();
        else cancelFormRetries();
        intent = false;
      });
    }

    // The header "Write a review" link opens the disclosure that holds the
    // Judge.me form (always the LAST block, after all native cards) and
    // smooth-scrolls to it. prefers-reduced-motion гасим тут вручную:
    // глобальное CSS-правило critical.css не властно над behavior из JS.
    // No-JS: the link is a plain #anchor and the <details> is toggled by
    // its own summary, so the form is still reachable.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.pdp-reviews__write');
      if (!link || !box) return;
      e.preventDefault();
      if (box.open) {
        ensureJdgmForm();
      } else {
        intent = true; // жест пользователя — toggle-хендлер откроет форму сам
        box.open = true;
      }
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });

    // "Show more reviews": progressively hide cards 5+ (no-JS users see all).
    var list = document.querySelector('.pr-list');
    var moreBtn = document.querySelector('[data-pr-more]');
    if (list && moreBtn && list.querySelector('.pr-item--more')) {
      list.classList.add('pr-collapsed');
      moreBtn.hidden = false;
      moreBtn.addEventListener('click', function () {
        list.classList.remove('pr-collapsed');
        moreBtn.hidden = true;
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    /* ----------------------------------------------------------------- *
     * Shared quick-add modal — one instance for the whole page, lazily
     * built and appended to <body>. Multi-variant cards open it to pick a
     * variant; single-variant cards add straight to cart. Add flow uses the
     * shared contract: POST /cart/add.js -> GET /cart.js -> dispatch
     * 'cart:updated' (the drawer opens itself).
     * ----------------------------------------------------------------- */
    var modal = null;
    var modalEls = null;
    var lastFocus = null;
    var current = null; // { data, selectedId }
    var CLOSE_MS = 260;

    function escapeAttr(str) {
      return String(str == null ? '' : str).replace(/"/g, '&quot;');
    }

    function buildModal(strings) {
      var el = document.createElement('div');
      el.className = 'qa-modal';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', strings.dialogLabel || 'Quick add');
      el.hidden = true;
      el.innerHTML =
        '<div class="qa-modal__bg" data-qa-close></div>' +
        '<div class="qa-modal__card">' +
        '<button type="button" class="qa-modal__close" data-qa-close aria-label="' +
        escapeAttr(strings.closeLabel || 'Close') +
        '"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<div class="qa-modal__top">' +
        '<img class="qa-modal__img" alt="" data-qa-img>' +
        '<div class="qa-modal__meta">' +
        '<div class="qa-modal__title" data-qa-title></div>' +
        '<div class="qa-modal__price"><span class="qa-modal__now" data-qa-now></span><s class="qa-modal__was" data-qa-was></s></div>' +
        '</div></div>' +
        '<div class="qa-modal__label" data-qa-label></div>' +
        '<div class="qa-modal__opts" data-qa-opts></div>' +
        '<button type="button" class="qa-modal__add" data-qa-add disabled></button>' +
        '</div>';
      document.body.appendChild(el);
      modal = el;
      modalEls = {
        card: el.querySelector('.qa-modal__card'),
        img: el.querySelector('[data-qa-img]'),
        title: el.querySelector('[data-qa-title]'),
        now: el.querySelector('[data-qa-now]'),
        was: el.querySelector('[data-qa-was]'),
        label: el.querySelector('[data-qa-label]'),
        opts: el.querySelector('[data-qa-opts]'),
        add: el.querySelector('[data-qa-add]')
      };
      return el;
    }

    function focusable() {
      if (!modalEls) return [];
      var nodes = modalEls.card.querySelectorAll(
        'button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])'
      );
      return Array.prototype.filter.call(nodes, function (n) {
        return n.offsetParent !== null;
      });
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      if (e.key === 'Tab') {
        var items = focusable();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function priceFor(variant) {
      modalEls.now.textContent = variant.price || '';
      if (variant.compare) {
        modalEls.now.classList.add('is-sale');
        modalEls.was.textContent = variant.compare;
        modalEls.was.hidden = false;
      } else {
        modalEls.now.classList.remove('is-sale');
        modalEls.was.textContent = '';
        modalEls.was.hidden = true;
      }
    }

    function openModal(wrap) {
      var script = wrap.querySelector('[data-qa-data]');
      if (!script) return;
      var data;
      try {
        data = JSON.parse(script.textContent);
      } catch (err) {
        return;
      }
      if (!modal) buildModal(data);
      current = { data: data, selectedId: null, wrap: wrap };

      /* src="" заставляет браузер перезапросить саму страницу */
      if (data.image) {
        modalEls.img.src = data.image;
        modalEls.img.hidden = false;
      } else {
        modalEls.img.removeAttribute('src');
        modalEls.img.hidden = true;
      }
      modalEls.title.textContent = data.title || '';
      modalEls.label.textContent = data.selectLabel || '';
      modalEls.add.textContent = data.selectLabel || '';
      modalEls.add.disabled = true;

      // Price defaults to the first available variant.
      var firstAvail = null;
      for (var f = 0; f < data.variants.length; f++) {
        if (data.variants[f].available) { firstAvail = data.variants[f]; break; }
      }
      priceFor(firstAvail || data.variants[0] || { price: '' });

      // Build option buttons.
      modalEls.opts.innerHTML = '';
      data.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qa-opt';
        b.textContent = v.title;
        b.setAttribute('data-variant-id', v.id);
        if (!v.available) {
          b.disabled = true;
          b.setAttribute('aria-label', v.title + ' — ' + (data.soldOut || 'Sold out'));
        }
        modalEls.opts.appendChild(b);
      });

      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.setAttribute('data-open', '');
      });
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      modalEls.card.querySelector('[data-qa-close]').focus();
    }

    // A successful quick-add opens the cart drawer, which locks the page scroll;
    // the modal then closes 400ms later and must not release a lock it does not
    // own. Same guard shape as assets/cart.js (which keeps its own isOpen flag).
    function otherOverlayOpen() {
      return !!document.querySelector(
        '[data-cart-drawer][data-open], [data-search-overlay][data-open], dialog[open]'
      );
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.removeAttribute('data-open');
      if (!otherOverlayOpen()) document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        if (!modal.hasAttribute('data-open')) modal.hidden = true;
      }, CLOSE_MS);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      current = null;
    }

    function selectOption(btn) {
      if (!current || btn.disabled) return;
      modalEls.opts.querySelectorAll('.qa-opt').forEach(function (o) {
        o.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      var id = btn.getAttribute('data-variant-id');
      current.selectedId = id;
      var variant = null;
      for (var i = 0; i < current.data.variants.length; i++) {
        if (String(current.data.variants[i].id) === String(id)) {
          variant = current.data.variants[i];
          break;
        }
      }
      if (variant) priceFor(variant);
      modalEls.add.disabled = false;
      modalEls.add.textContent = current.data.addLabel || 'Add to cart';
    }

    function addVariant(id, btn, wrap) {
      if (!id || btn.classList.contains('is-loading')) return;
      var original = btn.textContent;
      var addedText = (wrap && wrap.dataset.added) || 'Added';
      var errorText = (wrap && wrap.dataset.error) || 'Try again';
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          btn.textContent = addedText;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          var fromModal = modal && !modal.hidden && btn === modalEls.add;
          if (fromModal) {
            window.setTimeout(closeModal, 400);
          } else {
            window.setTimeout(function () { btn.textContent = original; }, 1400);
          }
        })
        .catch(function () {
          btn.textContent = errorText;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          setTimeout(function () { btn.textContent = original; }, 1600);
        });
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      // Colour swatch → swap primary image
      var swatch = event.target.closest('.pcard-swatch');
      if (swatch) {
        var card = swatch.closest('.pcard');
        if (card) {
          card.querySelectorAll('.pcard-swatch').forEach(function (el) { el.classList.remove('is-active'); });
          swatch.classList.add('is-active');
          var url = swatch.getAttribute('data-swatch-image');
          var primary = card.querySelector('.pcard-img.img-a');
          if (url && primary) {
            primary.removeAttribute('srcset');
            primary.src = url;
          }
        }
        return;
      }

      // Modal: close (backdrop or ✕)
      if (event.target.closest('[data-qa-close]')) {
        closeModal();
        return;
      }

      // Modal: option button
      var opt = event.target.closest('.qa-opt');
      if (opt) {
        selectOption(opt);
        return;
      }

      // Modal: add-to-cart
      var modalAdd = event.target.closest('[data-qa-add]');
      if (modalAdd) {
        if (!current || !current.selectedId) return;
        addVariant(current.selectedId, modalAdd, current.wrap);
        return;
      }

      // Quick-add trigger on a card
      var trigger = event.target.closest('[data-qa-btn]');
      if (trigger) {
        var wrap = trigger.closest('[data-quick-add]');
        if (!wrap) return;
        if (trigger.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }

        if (wrap.dataset.multi) {
          event.preventDefault();
          openModal(wrap);
          return;
        }

        // Single variant → AJAX add (fall through to PDP link if no variant id)
        var vid = wrap.dataset.variantId;
        if (!vid) return;
        event.preventDefault();
        addVariant(vid, trigger, wrap);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    // Single runtime source of truth (mirrors snippets/utility-product-check.liquid):
    // a product is "utility" (hidden from listings) when its handle starts with
    // "__" or its vendor is "re:do". Defined defensively so any theme block can
    // reuse the same predicate.
    window.viossiIsUtilityProduct = window.viossiIsUtilityProduct || function (handle, vendor) {
      var h = String(handle == null ? '' : handle).toLowerCase();
      var v = String(vendor == null ? '' : vendor).toLowerCase();
      return h.indexOf('__') === 0 || v === 're:do' || h === 'navidium-shipping-protection';
    };

    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var sheet = overlay.querySelector('.searchov-sheet');
    var input = overlay.querySelector('[data-search-input]');
    var defaultPanel = overlay.querySelector('[data-search-default]');
    var resultsPanel = overlay.querySelector('[data-search-results]');
    var status = overlay.querySelector('[data-search-status]');
    var predictiveUrl = overlay.getAttribute('data-predictive-url') || '/search/suggest';
    var searchUrl = overlay.getAttribute('data-search-url') || '/search';
    var moneyFormat = overlay.getAttribute('data-money-format') || '';
    // The money_format placeholder, matched by regex: writing it out literally
    // would read as a Liquid variable inside this static javascript block.
    var AMOUNT_RE = /\{\{[^{}]*\}\}/;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Tracks the intended state so a reopen during the 240ms close animation
    // is not swallowed by the `overlay.hidden` guard (the element is still
    // visible while the transition runs).
    var isOpen = false;
    var lastFocus = null;
    var debounceTimer = null;
    var controller = null;
    var optionEls = [];
    var activeIndex = -1;
    var idSeed = 0;

    var t = {
      products: 'Products',
      viewAll: 'View all results',
      searching: 'Searching…',
      resultCount: 'results',
      noResults: 'No matches. Try a different search.'
    };
    try {
      var cfg = JSON.parse(overlay.getAttribute('data-strings') || '{}');
      for (var k in cfg) { if (cfg[k]) t[k] = cfg[k]; }
    } catch (e) {}

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { overlay.setAttribute('data-open', ''); });
      input.value = '';
      showDefault();
      var focusNow = function () { input.focus(); };
      if (reduce) { focusNow(); } else { window.setTimeout(focusNow, 60); }
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      if (controller) { controller.abort(); controller = null; }
      overlay.removeAttribute('data-open');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      document.documentElement.style.overflow = '';
      var finish = function () { if (!isOpen) overlay.hidden = true; };
      if (reduce) { finish(); } else { window.setTimeout(finish, 240); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function showDefault() {
      resultsPanel.hidden = true;
      resultsPanel.innerHTML = '';
      defaultPanel.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      collectOptions();
    }

    function showResults() {
      defaultPanel.hidden = true;
      resultsPanel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function collectOptions() {
      var panel = resultsPanel.hidden ? defaultPanel : resultsPanel;
      optionEls = Array.prototype.slice.call(
        panel.querySelectorAll('[data-search-query], a[href], .srch-viewall')
      );
      optionEls.forEach(function (el) {
        if (!el.id) { el.id = 'srchopt-' + (++idSeed); }
        if (el.getAttribute('role') !== 'option') el.setAttribute('role', 'option');
      });
      activeIndex = -1;
    }

    function setActive(index) {
      if (!optionEls.length) return;
      if (activeIndex > -1 && optionEls[activeIndex]) {
        optionEls[activeIndex].removeAttribute('data-active');
        optionEls[activeIndex].setAttribute('aria-selected', 'false');
      }
      activeIndex = (index + optionEls.length) % optionEls.length;
      var el = optionEls[activeIndex];
      el.setAttribute('data-active', '');
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    // One full row of mini-cards. Ten are requested and only the four best
    // survive re-ranking, so the row is picked from a real candidate pool.
    var RESULT_LIMIT = 4;
    var FETCH_LIMIT = 10;

    function requestProducts(q, signal) {
      // Products only — articles, pages and collections never appear in search.
      var url = predictiveUrl +
        '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[limit]=' + FETCH_LIMIT +
        '&resources[options][unavailable_products]=last';
      var opts = { headers: { 'Accept': 'application/json' } };
      if (signal) opts.signal = signal;

      return fetch(url, opts)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          return (res.products || []).filter(function (p) {
            return !window.viossiIsUtilityProduct(p && p.handle, p && p.vendor);
          });
        });
    }

    // Predictive search is effectively AND-based: "green velvet blazer" returns
    // NOTHING when no single product carries all three words, while the OR-based
    // /search page returns 200+. Instead of showing an empty overlay, retry with
    // shorter queries, dropping one word at a time — "red bow tie" → "bow tie",
    // "grey blazer slim" → "blazer slim" → "grey blazer", "green velvet blazer"
    // → "velvet blazer" → "green velvet" → "green blazer". The colour+garment
    // pair comes last because it is the loosest of the pairs, and the whole
    // ladder stops as soon as there is a full row. Everything collected is
    // scored against the FULL original query, so the closest items stay on top.
    var MAX_BROADEN = 3;

    function broadenedQueries(q) {
      var words = q.split(/\s+/);
      var kept = [];
      var i;
      for (i = 0; i < words.length; i++) {
        if (words[i]) kept.push(words[i]);
      }
      var candidates = [];
      if (kept.length > 1) {
        candidates.push(kept.slice(1).join(' '));
        candidates.push(kept.slice(0, kept.length - 1).join(' '));
        candidates.push(kept[0] + ' ' + kept[kept.length - 1]);
        candidates.push(kept[kept.length - 1]);
      }
      var out = [];
      for (i = 0; i < candidates.length && out.length < MAX_BROADEN; i++) {
        if (candidates[i] !== q && out.indexOf(candidates[i]) === -1) out.push(candidates[i]);
      }
      return out;
    }

    // Shopify orders predictive hits by its own relevance model, which can put a
    // partial match ("Navy Leather Loafers") above the exact one ("Brown Leather
    // Loafers"). Re-score by how many query tokens each product matches.
    function rankProducts(q, products) {
      var ranker = window.viossiSearchRank;
      if (!ranker || products.length < 2) return products;
      var tokens = ranker.tokenize(q);
      if (tokens.length < 2) return products;
      return ranker.rank(products, function (p) {
        var tags = (p && p.tags && p.tags.join) ? p.tags.join(' ') : '';
        return ranker.score(tokens, (p && p.title) || '', (p && p.type) || '', tags);
      });
    }

    function fetchResults(q) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var signal = controller ? controller.signal : null;
      status.textContent = t.searching;

      var queue = broadenedQueries(q);
      var collected = [];
      var seen = {};

      function absorb(products) {
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          var key = String((p && (p.id || p.handle)) || i);
          if (seen[key]) continue;
          seen[key] = true;
          collected.push(p);
        }
      }

      function step(query) {
        return requestProducts(query, signal).then(function (products) {
          absorb(products);
          if (collected.length >= RESULT_LIMIT || !queue.length) {
            renderResults(q, collected);
            return null;
          }
          return step(queue.shift());
        });
      }

      step(q).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        renderError(q);
      });
    }

    function stripTags(str) {
      // Shopify money_format can carry HTML (e.g. <span class=money>$1</span>);
      // in a text node that markup must be stripped, not shown raw.
      return String(str).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    }

    // `amount` is in major units (349 → "$349"). Mirrors the Liquid
    // `money_without_trailing_zeros` used by the server-rendered panel
    // (snippets/search-overlay.liquid default results) and assets/pdp.js.
    function formatMoney(amount) {
      var num = Number(amount);
      if (!isFinite(num)) return '';
      // Разделители по типу плейсхолдера (полный набор, как в cart.js):
      // раньше *_separator-форматы получали точку вместо запятой («€356.95»).
      var typeMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var type = typeMatch ? typeMatch[1] : 'amount';
      var noDecimals = type.indexOf('no_decimals') !== -1;
      var thousands = ',';
      var decimal = '.';
      if (type === 'amount_with_comma_separator' || type === 'amount_no_decimals_with_comma_separator') {
        thousands = '.'; decimal = ',';
      } else if (type === 'amount_with_space_separator') {
        thousands = ' '; decimal = ',';
      } else if (type === 'amount_no_decimals_with_space_separator') {
        thousands = ' '; decimal = '';
      } else if (type === 'amount_with_apostrophe_separator') {
        thousands = "'"; decimal = '.';
      }
      var value = noDecimals ? Math.round(num).toString() : num.toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      // Как money_without_trailing_zeros: целые суммы без «,00»/«.00»
      var frac = parts[1] && Number(parts[1]) !== 0 ? decimal + parts[1] : '';
      value = parts[0] + frac;
      if (!AMOUNT_RE.test(moneyFormat)) return value;
      return stripTags(moneyFormat.replace(AMOUNT_RE, value));
    }

    function priceOf(p) {
      if (p == null) return '';
      if (typeof p.price === 'string' && p.price !== '') {
        // The predictive API returns major units as a string ("349.00").
        var cleaned = p.price.replace(/[^0-9.\-]/g, '');
        if (cleaned === '' || isNaN(Number(cleaned))) return stripTags(p.price);
        return formatMoney(cleaned);
      }
      if (typeof p.price === 'number') return formatMoney(p.price / 100);
      return '';
    }

    function imageOf(p) {
      if (!p) return '';
      if (typeof p.image === 'string') return p.image;
      if (p.featured_image && p.featured_image.url) return p.featured_image.url;
      return '';
    }

    // The results page is product-only too, so every hand-off carries `type`.
    function resultsHref(q) {
      return escapeHtml(searchUrl) + '?q=' + encodeURIComponent(q) + '&amp;type=product';
    }

    function renderResults(q, products) {
      var ranked = rankProducts(q, products);
      var html = '';

      if (ranked.length) {
        html += '<div class="srch-sec"><h5>' + escapeHtml(t.products) + ' (' + ranked.length + ')</h5><div class="srch-prod">';
        ranked.slice(0, RESULT_LIMIT).forEach(function (p) {
          var img = imageOf(p);
          var imgTag = img
            ? '<img loading="lazy" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '">'
            : '<span class="placeholder"></span>';
          html += '<a class="srch-mini" href="' + escapeHtml(p.url) + '">' + imgTag +
            '<div class="sm-t">' + escapeHtml(p.title) + '</div>' +
            '<div class="sm-p">' + escapeHtml(priceOf(p)) + '</div></a>';
        });
        html += '</div></div>';
        status.textContent = ranked.length + ' ' + t.resultCount;
      } else {
        // Predictive found nothing even after broadening, but /search is
        // OR-based and almost always has something, so still offer the way out.
        html = '<div class="srch-empty">' + escapeHtml(t.noResults) + '</div>';
        status.textContent = t.noResults;
      }
      html += '<a class="srch-viewall" href="' + resultsHref(q) + '">' + escapeHtml(t.viewAll) + '</a>';

      resultsPanel.innerHTML = html;
      showResults();
      collectOptions();
    }

    function renderError(q) {
      resultsPanel.innerHTML = '<a class="srch-viewall" href="' + resultsHref(q) + '">' +
        escapeHtml(t.viewAll) + '</a>';
      showResults();
      collectOptions();
    }

    function onInput() {
      var q = input.value.trim();
      window.clearTimeout(debounceTimer);
      if (!q) {
        if (controller) { controller.abort(); controller = null; }
        showDefault();
        status.textContent = '';
        return;
      }
      debounceTimer = window.setTimeout(function () { fetchResults(q); }, 300);
    }

    /* ---- Trigger (delegated, progressive enhancement) ---- */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-predictive-search-trigger]');
      if (trigger) {
        event.preventDefault();
        open();
        return;
      }
      var closer = event.target.closest('[data-search-close]');
      if (closer && overlay.contains(closer)) {
        event.preventDefault();
        close();
        return;
      }
      var chip = event.target.closest('[data-search-query]');
      if (chip && overlay.contains(chip)) {
        event.preventDefault();
        input.value = chip.getAttribute('data-search-query') || chip.textContent.trim();
        input.focus();
        onInput();
      }
    });

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', function (event) {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          setActive(activeIndex + 1);
          break;
        case 'ArrowUp':
          event.preventDefault();
          setActive(activeIndex - 1);
          break;
        case 'Enter':
          if (activeIndex > -1 && optionEls[activeIndex]) {
            event.preventDefault();
            optionEls[activeIndex].click();
          }
          break;
        case 'Escape':
          event.preventDefault();
          close();
          break;
      }
    });

    /* ---- Focus trap + global Escape ---- */
    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;

      var focusables = sheet.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      );
      var list = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    collectOptions();
  })();
  } catch(e) { console.error(e); }
})();

})();
